"use strict";

exports.__esModule = true;
exports.useControlled = useControlled;

var React = _interopRequireWildcard(require("react"));

var _useUncontrolled2 = require("./useUncontrolled");

var _useCallbackRef = require("./useCallbackRef");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useControlled(props) {
  var defaultValue = props.defaultValue,
      onChange = props.onChange,
      valueProp = props.value;

  var _React$useRef = React.useRef(valueProp !== undefined),
      isControlled = _React$useRef.current;

  var handleChange = (0, _useCallbackRef.useCallbackRef)(onChange);

  var _useUncontrolled = (0, _useUncontrolled2.useUncontrolled)({
    defaultValue: defaultValue,
    onChange: onChange
  }),
      uncontrolledValue = _useUncontrolled[0],
      setUncontrolledValue = _useUncontrolled[1];

  var value = isControlled ? valueProp : uncontrolledValue;
  var setValue = React.useCallback(function (nextValue) {
    if (isControlled) {
      var valueFn = nextValue;
      var newValue = typeof nextValue === 'function' ? valueFn(valueProp) : nextValue;

      if (newValue !== valueProp) {
        handleChange(newValue);
      }
    } else {
      setUncontrolledValue(nextValue);
    }
  }, [handleChange, isControlled, setUncontrolledValue, valueProp]);
  return [value, setValue];
}